import { render, staticRenderFns } from "./WxLogin.vue?vue&type=template&id=60a14efa&scoped=true"
import script from "./WxLogin.vue?vue&type=script&lang=ts"
export * from "./WxLogin.vue?vue&type=script&lang=ts"
import style0 from "./WxLogin.vue?vue&type=style&index=0&id=60a14efa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a14efa",
  null
  
)

export default component.exports